<div
  [ngClass]="config?.displayType"
  class="CoverageEffectiveDate"
  [zipBusy]="coverageFormErrorSubscription"
>
  <div class="form--group--wrapper" [hidden]="shouldDisableSEP">
    <form-control
      data-test-id="coverageEffectiveDateSEPForm"
      [config]="whichEnrollment"
      [group]="form"
      [control]="form.get(whichEnrollment.prop)"
    >
    </form-control>
  </div>

  @if (showCoverageDateSelector) {
    <div class="form--group--wrapper">
      <form-control
        data-test-id="coverageEffectiveDateSelector"
        [config]="effectiveDateDropdownConfig"
        [group]="form"
        [control]="form.get(effectiveDateDropdownConfig.prop)"
      >
      </form-control>
    </div>
  }

  @if (!isQLEenabled && !!enrollmentChosen) {
    <div>
      <h6
        data-test-id="coverageEffectiveDateSEPHeader"
        class="t-bold"
        [innerHTML]="formattedText.title"
      ></h6>
      @if (enrollmentChosen === 'SEP') {
        <p
          data-test-id="coverageEffectiveDateSEPSubTitle"
          class="t-data coverage-subtitle"
          [innerHTML]="formattedText.subtitle"
        ></p>
      }
    </div>
  }

  @if (checkForCoverageEffectiveErrorMessage) {
    <div class="CoverageEffectiveDate__errorMessage">
      <small
        data-test-id="coverageEffectiveDateErrorMessage"
        class="t-error t-bold"
        [innerHTML]="effectiveDateDropdownConfig?.errors?.customErrMessage"
      ></small>
    </div>
  }
  @if (showCoverageEffectiveText) {
    <h6
      data-test-id="coverageEffectiveDateTitle"
      class="t-bold"
      [innerHTML]="formattedText.title"
    ></h6>
  }
</div>
